import React, {useMemo} from 'react'
import DoneIcon from '@material-ui/icons/Done'
import './ColorCircle.scss'

const ColorCircle = ({
  diameter = 32,
  color = '#feb237',
  onClick,
  selected = false,
  icon = <DoneIcon style={{color: '#fff'}} />,
  style = {},
}) => {
  const Icon = useMemo(() => {
    const icon_diameter = Math.max(diameter - 8, diameter * 0.75)
    const style = {...(icon.props.style || {}), width: icon_diameter, height: icon_diameter}
    return React.cloneElement(icon, {style})
  }, [icon, diameter])

  return (
    <div
      className="c-color-circle"
      style={{backgroundColor: color, width: diameter, height: diameter, ...style}}
      onClick={onClick}
    >
      {selected && Icon}
    </div>
  )
}

export default ColorCircle
